export default "__VITE_ASSET__0e3d6567__"